<template>
  <v-container fluid>
    <v-row>
      <div class="header">
        <h2>Добавление новой публикации</h2>
      </div>
      <div class="horizontal-rule"/>
    </v-row>

    <CreationForm class="mt-6"/>
  </v-container>
</template>

<script>
import CreationForm from "@/components/ArticleCreationPageComponents/CreationForm";

export default {
  name: "ArticleCreationPage",
  components: {CreationForm}
}
</script>

<style scoped>

</style>